import React from 'react';
import "./Remarks.css";
import icon from "../../../assets/icons/ChatText.svg";

export default function Remarks(props) {
  return (
    <div className='remarks'>
      <div className='remark-img'>
        <img src={icon} alt="Error"/>
      </div>
      <div className='remark-desc'>
        <h5>{props?.food==="food" ? "Note : " : "Remarks :"} </h5>
        <p>{props.para}</p>
      </div>
    </div>
  )
}
